import { EmployeeTitle } from "@/Common/Models/Employee/Enums/EmployeeTitle";
import { Locale } from "@/Common/Models/Localization/Locale";

class LicenceOrganisationRule {
    public Id: string;
    public LicenceOrganisationCode: string;
    public NameEn: string;
    public NameFr: string;
    public NameEs: string;
    public StateCode: string;
    public CountryCode: string;
    public OrganisationCode: string;
    public OrganisationName: string;
    public Position: number;
    public ParentLicenceOrganisationId: string;
    public Acronym: string;
    public isActive: boolean;
    public Title: EmployeeTitle;
    public IsLegacy: boolean;

    public static readonly noOrganizationCode = "-";

    constructor(init?: Partial<LicenceOrganisationRule>) {
        Object.assign(this, init);
    }

    public static getTitleName(licenseOrganization: LicenceOrganisationRule): string {
        switch (sessionStore.locale) {
            case Locale.fr: return licenseOrganization?.NameFr ?? "";
            case Locale.es: return licenseOrganization?.NameEs ?? "";
            default: return licenseOrganization?.NameEn ?? "";
        }
    }

    public static getPosition(Model: LicenceOrganisationRule): number {
        if (Model && !isNaN(Model.Position))
            return Model.Position;
        else
            return 99;
    }

    public static getNameFromAnyLanguage(model: LicenceOrganisationRule): string {
        var LO = model;
        if (LO != null) {
            return LO.NameEn + " " + LO.NameFr + " " + LO.NameEs + " ";
        }

        return "";
    }

    public static getOrganisationCode(Model: LicenceOrganisationRule): string {
        var LO = Model;
        if (LO != null) {
            return LO.OrganisationCode;
        }
        return "";
    }

    public static getOrganisationName(Model: LicenceOrganisationRule): string {
        var LO = Model;
        if (LO != null) {
            return LO.OrganisationName;
        }
        return "";
    }

    public static getOrganizationAcronymAndName(model: LicenceOrganisationRule): string {
        return `${model.Acronym} - ${model.OrganisationName}`;
    }
}

export { LicenceOrganisationRule };
